import personImageSrc from 'components/OnePageTemplates/mockData/personPhoto.jpg';

import { ReactComponent as MockLogoWhite } from '../mockData/mockLogoWhite.svg';

export const EXAMPLE_DOC = {
  companyLogo: <MockLogoWhite />,
  companyName: 'Agrotech',
  projectBriefDescription:
    'Develop cold-resistant wheat, involves research, field trials, production scaling. Target market: agricultural sector, wheat cultivation. Acquisition rationale: address climate challenges, ensure food security.',
  lifeCycleStage: 'R&D',
  annualIncome: '$65,000,000',
  projectPaybackPeriod: '3 months',
  forecastedProfitability: '15%',
  fundingAmount: '$65,000,000',
  totalCost: '$65,000,000',
  percentageOfFunding: '30%',
  companyBriefDescription:
    'Leading agricultural biotechnology company based in USA, specializing in researching, developing, and commercializing innovative grain crop varieties. The company focuses on delivering cutting-edge solutions to address the evolving needs of farmers and the broader food industry. The Company uses molecular biology techniques to select and genetic modification to create high-performance crop varieties that exhibit improved yield, disease resistance, and adaptability to diverse environmental conditions.',
  operatingIndustry: 'Researching, developing, and commercializing innovative grain crop varieties',
  registrationDate: '11.11.2002',
  numberOfEmployees: '150',
  mainGoals:
    'Develop cold-resistant wheat, invest in research, scale production, ensure sustainability. Key strategies: R&D investment, collaboration, market expansion, track performance.',
  strategyForAchievingGoals:
    'Developing grains with enhanced cold resistance can give farmers a more resilient and adaptive crop variety. These cold-resistant grains would be specifically engineered to withstand extreme cold temperatures, ensuring better survival rates and sustained growth even in adverse winter conditions. This technological advancement aims to mitigate the impact of cold on grain crops, ultimately contributing to increased yields, economic stability for farmers, and food security for the nation.',
  mainProductsOrServices:
    'Specializing in coldresistant wheat varieties, the company ensures farmers access resilient crops thriving in harsh climates. It offers Wheat Variety 1, designed for cold climate zone fields, with plans for Wheat Variety 2, boasting higher cold tolerance.',
  competitionAdvantage:
    'Develop cold-resistant wheat, involves research, field trials, production scaling. Target market: agricultural sector, wheat cultivation. Acquisition rationale: address climate challenges, ensure food security.',
  targetMarket:
    'Target market comprises wheat farms in South Dakota and North Dakota. In 2022, South Dakota cultivated 4 million tons, North Dakota 4.2 million tons. Combined market value estimated at $103 billion. 20,501 wheat farms in South Dakota, 21,003 in North Dakota in 2022',
  mainCompetitors:
    '120 supplier companies compete in the wheat grain supply market. American AGRO leads with 15% market share. Other competitors: EcoWheat, Grain Processing Corporation.',
  targetChannels:
    'Customers include 41,505 medium and small wheat farmers in South Dakota and North Dakota. Characteristics of North Dakota farmers: aged 20-50, operate small to medium farms, seek drought-tolerant wheat varieties and sustainable farming practices.',
  revenueStreams:
    'The main revenue streams include sales of genetically modified crop seeds, licensing agreements for intellectual property rights, and consulting services for crop development. Critical financial assumptions involve market demand for high-performance varieties, successful R&D outcomes, farmer adoption, regulatory approvals, and operational efficiency. Key partners encompass research institutions, agricultural associations, seed distributors, and regulatory bodies to support innovation, market reach, and compliance within the industry.',
  marketingStrategy:
    'Agricultural Retailers and Cooperatives, Online Platforms and E-commerce, Seed Distributors and Wholesalers',
  projectStatus: ['Research and Development'],
  team: 'The core team members of the project include: Edward Lando — CEO (Chief Executive Officer), Naval Ravikant — CFO (Chief Financial Officer), Fabrice Grinda — Lead Scientist',
  dynamics:
    'Agricultural land increases by 2 thousand hectares annually in South Dakota and North Dakota. Market size expected to grow at 4% CAGR from 2022 to 2030 due to technological advancements and regulatory support for GMOs',
  problemOfMarket:
    'Farmers in the US grain market face a significant challenge due to the adverse effects of increasingly unpredictable and harsh winter weather conditions. The vulnerability of traditional grain crops to extreme cold temperatures often leads to reduced yields, crop failures, and financial losses for farmers. This susceptibility to cold weather threatens the overall stability and productivity of the US grain market.',
  projectedAnnualIncome: '65000000',
  projectedAnnualProfit: '65000000',
  returnOnInvestment: '20',
  internalRateOfReturn: '25',
  teamMembers: [
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finance',
      workExperience:
        "April 2017 — May 2020, ARP Dend, Finance manager\nDeveloping and maintaining financial models to forecast the company's financial performance. Analyzes financial data to provide insights into revenue trends, cost structures, and profitability. Assesses the company's financial risks and develops strategies to mitigate them",
      keySkills: 'Problem solving',
      achievements:
        "Spearheaded the company's expansion into 12 new markets, resulting in a 40% increase in global revenue",
    },
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finance',
      workExperience:
        "April 2017 — May 2020, ARP Dend, Finance manager\nDeveloping and maintaining financial models to forecast the company's financial performance. Analyzes financial data to provide insights into revenue trends, cost structures, and profitability. Assesses the company's financial risks and develops strategies to mitigate them",
      keySkills: 'Problem solving',
      achievements:
        "Spearheaded the company's expansion into 12 new markets, resulting in a 40% increase in global revenue",
    },
    {
      fullName: 'Edward Lando',
      position: 'CEO (Chief Executive Officer)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Oklahoma State University, Finance',
      workExperience:
        "April 2017 — May 2020, ARP Dend, Finance manager\nDeveloping and maintaining financial models to forecast the company's financial performance. Analyzes financial data to provide insights into revenue trends, cost structures, and profitability. Assesses the company's financial risks and develops strategies to mitigate them",
      keySkills: 'Problem solving',
      achievements:
        "Spearheaded the company's expansion into 12 new markets, resulting in a 40% increase in global revenue",
    },
  ],
  contacts: {
    websiteUrl: 'agrotech.com',
    phone: '1(062)7266363',
    email: 'office@agrotech.com',
    fullNameWithPos: 'John Doe, CEO',
    address: '699 Walnut St. Suite 1800, Des Moines, IA 50309, United States.',
  },
  financingNeedsChart: {
    otherCost: { percentage: '8.333333333333332', currencyAmount: '50' },
    researchCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    equipmentCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    marketingCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    constructionCost: { percentage: '25', currencyAmount: '150' },
    workingCapitalCost: { percentage: '16.666666666666664', currencyAmount: '100' },
  },
  implementationPlanStages: [
    {
      stage: 'Research and development (R&D) Planning',
      from: '2024-01-05T21:00:00.000Z',
      to: '2024-02-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Conduct initial cold-resistance analysis',
      from: '2024-02-05T21:00:00.000Z',
      to: '2024-03-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Develop genetic modification strategies (if applicable)',
      from: '2024-03-05T21:00:00.000Z',
      to: '2024-05-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Seed selection and procurement',
      from: '2024-04-05T21:00:00.000Z',
      to: '2024-08-05T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Establish test fields',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Plant cold-resistant wheat varieties',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Analyze results and refinement',
      from: '2024-08-05T21:00:00.000Z',
      to: '2024-08-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Production scaling',
      from: '2024-09-05T21:00:00.000Z',
      to: '2024-10-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Marketing and sales strategy development',
      from: '2024-10-05T21:00:00.000Z',
      to: '2024-12-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Product launch',
      from: '2024-12-05T21:00:00.000Z',
      to: '2024-12-25T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
  ],
};
